import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SimulateMultiComponent } from './simulate-multi.component';

const routes: Routes = [
  {
    path: '',
    component: SimulateMultiComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SimulateMultiRoutingModule { }
